import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/login/login';
import Home from '@/pages/home/home';
import frboard from '@/pages/fr/board/board';
import frcategory from '@/pages/fr/category/category';
import fr8dReport from '@/pages/fr/report/8d/board';
import fr5whyReport from '@/pages/fr/report/5why/board';
import frA3Report from '@/pages/fr/report/a3/board';
import frStatisReport from '@/pages/fr/statis/board';
import frSchedule from '@/pages/fr/schedule/board';
import frResponse from '@/pages/fr/response/board';
import frApprove from '@/pages/fr/approve/board';
import frEightd from '@/pages/fr/8d/board';
import frWhy from '@/pages/fr/5why/board';
import frA3 from '@/pages/fr/a3/board';
import frGroupBoard from '@/pages/fr/groups/board';
import frGroupReport from '@/pages/fr/report/groups/board';
import frTrackingListBoard from '@/pages/fr/trackinglist/board';
import frSourceReport from '@/pages/fr/report/source/board';

import andonboard from '@/pages/andon/board/board';
import lpaboard from '@/pages/layeraudit/board/board';
import lpacategory from '@/pages/layeraudit/category/category';
import lpaplan from '@/pages/layeraudit/plan/board';
import ehsboard from '@/pages/ehs/board/board';
import eiboard from '@/pages/ei/board/board';
import Tenants from '@/pages/home/tenants';
import qplot from '@/pages/fr/qplot/board';
import oeeboard from '@/pages/oee/board/board';
import oeeProduct from '@/pages/oee/productLine/board';
import oeeMonthly from '@/pages/oee/monthly/board';
import oeeIssueTop from '@/pages/oee/issue-top/oee-list/board';
import oeeFtqTop from '@/pages/oee/issue-top/ftq-list/board';

import escalationBoard from '@/pages/escalation/board/board';
import boxCategory from '@/pages/box/category/category';
import Box from '@/pages/box/board/board';
import BoxItem from '@/pages/box/board/item';
import oeeMmCategory from '@/pages/oee/mm/category/category';
import oeeQc from '@/pages/oee/mm/qc/board';
import oeeSc from '@/pages/oee/mm/sc/board';
import oeeRegister from '@/pages/oee/mm/register/board';
import oeeCategory from '@/pages/oee/category/category';
import oeeoutputBoard from '@/pages/oee/weektracking/output/board';
import trackingListBoard from '@/pages/oee/weektracking/trackinglist/board';
import oeeKpiBoard from '@/pages/oee/weektracking/kpi/board';
import oeeWeektrackingCategory from '@/pages/oee/weektracking/category/category';

import nokBoard from '@/pages/nok/board/board';

import mickpiBoard from '@/pages/mickpi/board';

import cpmBoard from '@/pages/cpm/board';

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '',
      redirect: '/home'
    },
    {
      path: '/tenants',
      component: Tenants,
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/home',
      component: Home
    },
    {
      path: '/fr/board',
      component: frboard
    },
    {
      path: '/fr/category',
      component: frcategory
    },
    {
      path: '/fr/qplot',
      component: qplot
    },
    {
      path: '/fr/8d/report',
      component: fr8dReport
    },
    {
      path: '/fr/a3/report',
      component: frA3Report
    },
    {
      path: '/fr/5why/report',
      component: fr5whyReport
    },
    {
      path: '/fr/statis',
      component: frStatisReport
    },
    {
      path: '/fr/schedule',
      component: frSchedule
    },
    {
      path: '/fr/response',
      component: frResponse
    },
    {
      path: '/fr/approve',
      component: frApprove
    },
    {
      path: '/fr/8d',
      component: frEightd
    },
    {
      path: '/fr/5why',
      component: frWhy
    },
    {
      path: '/fr/a3',
      component: frA3
    },
    {
      path: '/fr/groups',
      component: frGroupBoard
    },
    {
      path: '/fr/group_report',
      component: frGroupReport
    },
    {
      path: '/fr/source_report',
      component: frSourceReport
    },
    {
      path: '/fr/tracking_list',
      component: frTrackingListBoard
    },
    {
      path: '/andon/board',
      component: andonboard
    },
    {
      path: '/layeraudit/board',
      component: lpaboard
    },
    {
      path: '/layeraudit/category',
      component: lpacategory
    },
    {
      path: '/layeraudit/plan',
      component: lpaplan
    },
    {
      path: '/ehs/board',
      component: ehsboard
    },
    {
      path: '/ei/board',
      component: eiboard
    },
    {
      path: '/nok/board',
      component: nokBoard
    },
    {
      path: '/cpm/board',
      component: cpmBoard
    },
    {
      path: '/oee/category',
      component: oeeCategory
    },
    {
      path: '/oee/board',
      component: oeeboard
    },
    {
      path: '/oee/issue-top',
      component: oeeIssueTop
    },
    {
      path: '/oee/ftq-top',
      component: oeeFtqTop
    },
    {
      path: '/oee/productLine',
      component: oeeProduct
    },
    {
      path: '/oee/monthly',
      component: oeeMonthly
    },
    {
      path: '/oee/mm/category',
      component: oeeMmCategory
    },
    {
      path: '/oee/mm/qc',
      component: oeeQc
    },
    {
      path: '/oee/mm/register',
      component: oeeRegister
    },
    {
      path: '/oee/weekCategory',
      component: oeeWeektrackingCategory
    },
    {
      path: '/oee/weektracking_output',
      component: oeeoutputBoard
    },
    {
      path: '/oee/weektracking_list',
      component: trackingListBoard
    },
    {
      path: '/oee/weektracking_kpi',
      component: oeeKpiBoard
    },
    {
      path: '/oee/mm/sc',
      component: oeeSc
    },
    {
      path: '/escalation/board',
      component: escalationBoard
    },
    {
      path: '/box/category',
      component: boxCategory
    },
    {
      path: '/box/board',
      component: Box
    },
    {
      path: '/box/item',
      component: BoxItem
    },
    {
      path: '/mickpi/board',
      component: mickpiBoard
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js